'use client';

import { LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
import { type FC, useMemo } from 'react';
import wheelPositionEN from '@/assets/helio/wheel-position-en.svg';
import wheelPositionFR from '@/assets/helio/wheel-position-fr.svg';
import { useLingui } from '@lingui/react';
import { PositionInWheelScatter } from '@prismo-io/charts';
type Props = {
  radiusAxis: number;
  angleAxis: number;
};
export const WheelPositionSection: FC<Props> = (props: Props) => {
  const {
    radiusAxis,
    angleAxis
  } = props;
  const {
    i18n
  } = useLingui();
  const wheelPositionImg = useMemo(() => {
    if (i18n.locale as LanguageCodeT === LanguageCode.enum.fr) {
      return wheelPositionFR;
    }
    return wheelPositionEN;
  }, [i18n.locale]);
  return <PositionInWheelScatter img={wheelPositionImg} positions={[[radiusAxis, angleAxis]]} data-sentry-element="PositionInWheelScatter" data-sentry-component="WheelPositionSection" data-sentry-source-file="section.tsx" />;
};